import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  IconButton,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import {
  resetCSVFileData,
  setIsOpenImportedSubscribersDialog,
  useImportCSVData,
} from 'app/store/importCSV'
import CheckCircleOutlineIcon from 'app/components/icons/CheckCircleOutlineIcon'
import { Routes } from 'app/services/routeService/routeService'

import useStyles from './styles'

const DialogImportedSubscribers = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    data: { rows, importedSubscribersCount },
    isOpenImportedSubscribersDialog,
  } = useImportCSVData()

  const classes = useStyles()

  const onClose = () => {
    if (rows?.length === 0) {
      dispatch(resetCSVFileData())
    }
    dispatch(setIsOpenImportedSubscribersDialog(false))
  }

  const importAnotherCSV = () => {
    onClose()
    dispatch(resetCSVFileData())
  }

  const goToSubscriberCRM = () => {
    onClose()
    history.push(Routes.subscribersV4())
  }

  return (
    <Dialog
      className={clsx(classes.dialogWrap)}
      open={isOpenImportedSubscribersDialog}
    >
      <DialogTitle>
        <div className={classes.dialogTitle}>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
          <CheckCircleOutlineIcon classes="w-40" />
          <FormattedMessage id="subscribers.import.dialogImportedSubscribers.title" />
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FormattedMessage
          id="subscribers.import.dialogImportedSubscribers.description"
          values={{ importedSubscribersCount }}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          variant="outlined"
          onClick={importAnotherCSV}
          className={classes.actionbutton1}
        >
          <FormattedMessage id="subscribers.import.dialogImportedSubscribers.actionBtn1.label" />
        </Button>
        <Button
          variant="contained"
          onClick={goToSubscriberCRM}
          className={classes.actionbutton2}
        >
          <FormattedMessage id="subscribers.import.dialogImportedSubscribers.actionBtn2.label" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogImportedSubscribers
